var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.profileType === 'importedPaidWarrants')?_c('PaidWarrantsProcessedDetails',{attrs:{"program":_vm.program,"chunkID":_vm.chunkID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }